
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';

import CarsBoatsVehiclesFsSurvey from "./CarsBoatsVehiclesFSSurvey.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import PageBase from "../../PageBase.vue";


import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
      CarsBoatsVehiclesFsSurvey,
      PageBase
    }
})
export default class CarsBoatsVehiclesFS extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void
    

    @Watch('carsBoatsVehiclesData')
    carsBoatsVehiclesDataChange(newVal) 
    {
        this.UpdateStepResultData({step:this.step, data: {carsBoatsVehiclesFSSurvey: this.getCarsBoatsVehiclesResults()}})  
    }

    currentStep =0;
    currentPage =0;
    showTable = true;
    carsBoatsVehiclesData = [];
    anyRowToBeEdited = null;
    editId = null;
 
    created() {
        if (this.step.result?.carsBoatsVehiclesFSSurvey?.data) {
            this.carsBoatsVehiclesData = this.step.result.carsBoatsVehiclesFSSurvey.data;
        }
    }

    mounted(){        
        const progress = this.carsBoatsVehiclesData?.length>0? 100 : 50;            
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
        Vue.nextTick(()=>{
            const el = document.getElementById('cars-boats-vehicles-fs-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {
        this.showTable = value;
    }

    public populateSurveyData(carsBoatsVehiclesValue) {
        const currentIndexValue = this.carsBoatsVehiclesData?.length > 0 ? this.carsBoatsVehiclesData[this.carsBoatsVehiclesData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newCarsBoatsVehicles = { ...carsBoatsVehiclesValue, id };

        this.carsBoatsVehiclesData = this.carsBoatsVehiclesData? [...this.carsBoatsVehiclesData, newCarsBoatsVehicles]:[newCarsBoatsVehicles];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
        this.carsBoatsVehiclesData = this.carsBoatsVehiclesData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
    }

    public editRow(editedRow) {
        this.carsBoatsVehiclesData = this.carsBoatsVehiclesData.map(data => {
            return data.id == this.editId ? editedRow : data;
        });
        this.showTable = true;
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    public isDisableNext() {    
        if(this.carsBoatsVehiclesData?.length > 0) return false;
        else return true;
    }    

    beforeDestroy() {
        const progress = this.carsBoatsVehiclesData?.length>0? 100 : 50;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        this.UpdateStepResultData({step:this.step, data:{carsBoatsVehiclesFSSurvey: this.getCarsBoatsVehiclesResults()}})       
    }
   
    public getCarsBoatsVehiclesResults(){
        const questionResults: {name:string; value: string[]; title:string; inputType:string}[] =[];
        if(this.carsBoatsVehiclesData)
            for(const carsBoatsVehicles of this.carsBoatsVehiclesData)
            {
                questionResults.push({name:'carsBoatsVehiclesFSSurvey', value: this.getCarsBoatsVehiclesInfo(carsBoatsVehicles), title:'Cars, boats or vehicles '+carsBoatsVehicles.id +' Information', inputType:''})
            }

        return {data: this.carsBoatsVehiclesData, questions:questionResults, pageName:'Cars, boats or vehicles', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getCarsBoatsVehiclesInfo(carsBoatsVehicles){        
        const resultString: string[] = [];
        resultString.push(Vue.filter('styleTitle')("Description: ")+carsBoatsVehicles.carsBoatsVehiclesDescription);
        resultString.push(Vue.filter('styleTitle')("Value: ")+carsBoatsVehicles.carsBoatsVehiclesValue);
        return resultString
    }

}
